import { render, staticRenderFns } from "./CompanyMenuNewRestaurantDialog.vue?vue&type=template&id=56e25e5e"
import script from "./CompanyMenuNewRestaurantDialog.vue?vue&type=script&lang=js"
export * from "./CompanyMenuNewRestaurantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports